import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-job-schedules',
  templateUrl: './job-schedules.component.html',
  styleUrls: ['./job-schedules.component.css']
})
export class JobSchedulesComponent implements OnInit {
    public setting?: Setting;

    public itemsListSchedules: Item[] = [];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1661))[0];
    }

    private async loadSchedules() {
        this.itemsListSchedules = await this.datatask.Post(1662);
    }

    private async init() {
        this.loadSetting();
        this.loadSchedules();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
